/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

//Styling

import "bootstrap/dist/css/bootstrap.min.css"
import "./src/styles/nav.scss"
import "./src/styles/_landing.scss"
import "./src/styles/_section.scss"
import "./src/styles/about.scss"
import "./src/styles/footer.scss"
